'use es6';

import { Record } from 'immutable'; // The bare miniumum necessary to identify a unique ad account,
// regardless of whether the rest of the record changes.

const AdAccountIdentityRecord = Record({
  accountId: null,
  network: null,
  adAccountAssignees: null
});
export default AdAccountIdentityRecord;